<template>
  <div class="border-t border-gray-200">
    <table class="w-full table-auto text-sm text-left">
      <thead class="bg-grey-light-100 text-grey-light-600 font-medium border-b border-gray-200">
        <tr>
          <th class="px-6 py-4">Item</th>
          <th class="px-6 py-4 text-right">Fees - Excl VAT</th>
          <th class="px-6 py-4 text-right">VAT</th>
          <th class="px-6 py-4 text-right">Total Fees - Incl VAT</th>
        </tr>
      </thead>
      <tbody class="text-grey-light-600">
        <template v-if="invoice?.feesPerProduct?.length && invoice?.feesPerProduct?.length > 0">
          <tr v-for="fee in invoice?.feesPerProduct" :key="fee.product?.displayName" class="border-b border-gray-200">
            <td class="p-6">{{ fee.product?.displayName }}</td>
            <td class="p-6 text-right">{{ displayCurrency(fee.amountExcludingVAT) }}</td>
            <td class="p-6 text-right">{{ displayCurrency(fee.amountVAT) }}</td>
            <td class="p-6 text-right">{{ displayCurrency(fee.amountTotal) }}</td>
          </tr>
        </template>
        <tr>
          <td class="p-6 text-gray-900 font-semibold">Total Amount</td>
          <td class="p-6 text-gray-900 font-semibold text-right">
            {{ displayCurrency(invoice?.exVatAmount || 0) }}
          </td>
          <td class="p-6 text-gray-900 font-semibold text-right">
            {{ displayCurrency(invoice?.vatAmount || 0) }}
          </td>
          <td class="p-6 text-gray-900 font-semibold text-right">
            {{ displayCurrency(invoice?.totalAmount || 0) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { displayCurrency } from '@/utils/format.utils';
import type { ModelInvoiceReport } from '@layup/api-sdk';

defineProps<{ invoice: ModelInvoiceReport | undefined }>();
</script>
